if (!customElements.get('quickview-button')) {
  class QuickviewButton extends ModalOpener {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('dawn:open-quickview', { detail: { url: this.dataset.url, opener: this } }));
      });
    }
  }
  customElements.define('quickview-button', QuickviewButton);
}
